import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "src/hooks/useRequest";

export const useFeedback = (query: Record<string, QueryParamsType>) => {
  const url = `/feedbacks?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    feedbacks: (data as any) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
